import { render } from "./ListaPedidosEntreguesView.vue?vue&type=template&id=1595e9c0&scoped=true"
import script from "./ListaPedidosEntreguesView.vue?vue&type=script&lang=js"
export * from "./ListaPedidosEntreguesView.vue?vue&type=script&lang=js"

import "./ListaPedidosEntreguesView.vue?vue&type=style&index=0&id=1595e9c0&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1595e9c0"]])

export default __exports__